import { useEffect } from 'react';

// Simple cache to avoid reloading same images
const loadedImages = new Set<string>();

export function usePreloadImages(imagesToPreload: string[]) {
  useEffect(() => {
    const preloadImages = async () => {
      try {
        const promises = imagesToPreload
          .filter((image) => !loadedImages.has(image)) // Skip already loaded
          .map((image) => {
            return new Promise<void>((resolve, reject) => {
              const img = new Image();
              img.src = image;
              img.onload = () => {
                loadedImages.add(image);
                resolve();
              };
              img.onerror = reject;
            });
          });
        await Promise.all(promises);
      } catch (error) {
        console.log(error);
      }
    };
    preloadImages();
  }, [imagesToPreload]);
}
